import React, { useState, useEffect } from "react";
// import {} from 'react-router-dom'
import { useSelector } from "react-redux";
// import { useGetAllObjectiveByPersonId } from "../../Hooks";
import { Grid, Box, Typography } from "@mui/material";
import { AllOKRComponentFace } from "../../Interfaces/Interfaces";
import { ReactComponent as ObjectiveVector } from "../../StaticData/Svgs/ObjectiveVector.svg";
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
// import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
// import CreateObjective from "../../Forms/CreateObjective/CreateObjective";
// import EditObjective from "../../Forms/EditObjective/EditObjective";
import { CircularProgress } from "@mui/material";
import { useGetMyKeyResultByTenantId
} from '../../../TenantDash/Hooks/index';
import { useNavigate } from "react-router-dom";
import OKRsCart from "../../../OKRManagment/LComponents/OKRsCart/OKRsCart";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { EditKeyResult } from "../../Forms/EditKeyResult/EditKeyResult";
import { useGetAllPersonPictureByTenantId } from "../../../AllTenantOkrs/Hooks";

const MyKeyResults = ({
  periodId,
  periodsData,
  getObjectiveLoading,
  isFetched,
  filterIsOn,
  afterSuccess
}: AllOKRComponentFace) => {
  // const navigate = useNavigate();
  //AMIR
  //const [allObjective, setAllObjective] = useState<any[]>();
  const profileTenantId = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  //AMIR
  //   const {
  //     data: objetcideData,
  //     //isLoading: getObjectiveLoading,
  //     isError,
  //     //isFetched,
  //     refetch: getObjectivesAgain,
  //   } = useGetAllObjectiveByPersonId(periodId, profileTenantId);
  const{data:personPicture,isLoading:loadingg}=useGetAllPersonPictureByTenantId(profileTenantId);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [showToastMessage3, setShowToastMessage3] = useState<boolean>(false);
  // const [addObjectiveStatus, setAddObjectiveStatus] = useState<any>(null);
  const [krId, setKrId] = useState<any>();
  const [Item, setIteam] = useState<any>();
  const [objectiveAsynOpcState, setObjectiveAsyncOpState] = useState<any>(null);
  const [objectiveId, setObjectiveId] = useState<string | null>(null);
  const[addKrState,setAddKrState]=useState<any>(null);
  // const [showEditObjective, setShowEditObjective] = useState<any>(
  //   false
  // );
  const localE = () => {
  };
  const{data:keyresultData,isLoading:getKeyresultLoading,refetch:getObjDataAgain}
  =useGetMyKeyResultByTenantId(periodId,profileTenantId)
  const[showEditKr,setShowEditKr]=useState<boolean>(false);

  useEffect(() => {
    if (krId) {
      setShowEditKr(true)
    }
     
    }, [krId])

  if (getObjectiveLoading || !keyresultData || isFetched !== true) {
    return (
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"100%"}
        height={"500px"}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {keyresultData?.length === 0 && (
            <Grid item xs={12}>
              <Box width={"100%"} textAlign={"center"} p={2}>
                <div className="w-full h-80 flex justify-center">
                  <ObjectiveVector />
                </div>
                {!filterIsOn && (
                  <>
                    <Box mt={3}>
                      <Typography textAlign={"center"} variant="body2">
                        نتیجه کلیدی در این دوره‌‌زمانی تعریف نشده است.
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
          )}
        </Grid>

        <Grid item xs={12}>
          {keyresultData.length > 0 && (
            <Grid container>
              <Grid item xs={12}  px={1.5}>
                <Grid container spacing={1}>
                  {keyresultData &&
                    keyresultData.map((item: any, i: number) => {
                      return (
                        <Grid item xs={12} sm={4}>
                          <Box
                              key={i}
                              sx={{
                                transition: "all 0.3s ease",
                                "&:hover": {
                                  transform: "scale(1.05)",
                                  backgroundColor: "withesmoke",
                                  // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                                  // borderRadius: "12px",
                                },
                                padding: "10px", // Add padding to ensure content isn't cut off during hover
                              }}
                            >
                            <OKRsCart
                              setKrId={setKrId} 
                              setShowEditKr={setShowEditKr}  
                              setShowToastMessage={setShowToastMessage}
                              afterSuccess={keyresultData}
                              personPicture={personPicture}
                              setObjectiveId={setObjectiveId}
                              item={item}
                              setIteam={setIteam}
                              setObjectiveAsyncOpState={
                                setObjectiveAsyncOpState
                              }
                            />
                          </Box>
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
            {
              showEditKr && <ModalLyt 
              showModal={showEditKr}
              setShowModal={setShowEditKr}
              title={'ویرایش نتیجه کلیدی'}
              >
              <EditKeyResult  
              definitionId = {""}
              setShowEditKeyResult={setShowEditKr}
              editKrSuccess={getObjDataAgain}  
              setShowToastMessage={setShowToastMessage}
              setAddKrState={setAddKrState}
              setShowToastMessage3={setShowToastMessage3}
              krId={krId}
              Item={Item}
          />
          </ModalLyt>
        }
        {showToastMessage && (
          <DYToastMessage
            isSuccess={objectiveAsynOpcState?.isSuccess}
            message={objectiveAsynOpcState?.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {showToastMessage3 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage3}
            show={showToastMessage3}
          />
        )}
      </Grid>
    </>
  );
};

export default MyKeyResults;
